module.exports = __webpack_public_path__ + "static/media/vi.cf0d0ed2.svg";